<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"></CommonBreadCrumbs>
    <div class="">
      <div class="flex flex-col justify-center">
        <HelpHeroCard :heroCardData="adviceDetail"></HelpHeroCard>
        <div class="bg-stone-white">
          <NuxtLayout name="center" class="my-16 md:mt-40 md:mb-24 lg:mb-32">
            <div class="grid md:grid-cols-2 gap-10 md:gap-20 lg:gap-40 xl:gap-60">
              <div v-for="(item, index) in adviceDetail.categories" :key="index" class="mx-1">
                <HelpCard :cardData="item"></HelpCard>
              </div>
              <div class="flex flex-col justify-start space-y-4" v-if="adviceDetail.popular_topics?.length > 0">
                <div class="flex space-x-6 p-4">
                  <div class="">
                    <NuxtImg
                      loading="lazy"
                      src="/icons/book-open.svg"
                      alt="BookOpenIcon"
                      class="w-full"
                      width="62"
                      height="57"
                    />
                  </div>
                  <div class="flex flex-col justify-between">
                    <h3>{{ $t("helpAdvice.topics.title") }}</h3>
                    <span class="text-sm">
                      {{ $t("helpAdvice.topics.info") }}
                    </span>
                  </div>
                </div>
                <div class="flex flex-col">
                  <HelpList
                    :categorySlug="adviceDetail.categories?.[0]?.slug"
                    :listData="item"
                    v-for="(item, index) in adviceDetail.popular_topics"
                    :key="index"
                    :total="adviceDetail.popular_topics?.length"
                  ></HelpList>
                </div>
              </div>
            </div>
          </NuxtLayout>
        </div>
      </div>
      <NuxtLayout name="center" class="md:mx-auto mx-4">
        <CommonLiveChatBlock></CommonLiveChatBlock>
      </NuxtLayout>
      <div class="bg-secondary-lighter pt-14 pb-8 md:py-16" v-if="adviceDetail.faq_topics?.length > 0">
        <NuxtLayout name="center" class="text-left md:text-center">
          <h2 class="mb-8">{{ $t("condition.faqTopic") }}</h2>
          <CommonTopicCard :list="adviceDetail.faq_topics" card_type="faqs"></CommonTopicCard>
          <div class="my-12 flex justify-center">
            <NuxtLinkLocale :locale="switchBlogLocale()" to="/faqs">
              <BaseButton
                class="md:w-90 w-full h-[60px] mx-0 bg-white text-lg"
                variant="outlined"
                :text="$t('faq.viewAll')"
              ></BaseButton>
            </NuxtLinkLocale>
          </div>
        </NuxtLayout>
      </div>

      <div class="">
        <NuxtLayout name="center" class="pt-14 md:pt-20 pb-4">
          <CommonHowItWorks />
        </NuxtLayout>
      </div>

      <ClinicCTABlock imgSrc="USPs_graphic_03_1" class="md:mt-16" :getStarted="true"></ClinicCTABlock>
    </div>
  </div>
</template>

<script setup>
const adviceDetail = ref({});
const { data: resultData } = await useHelpAdviceDetail();
adviceDetail.value = resultData.value.data;
// const { data: topicData, pending, error: errorMessage, refresh } = await useFaqTopicList();
// topicLists.value = topicData.value.data

useMetaTitles(adviceDetail.value, "help-and-advice");

const breadcrumbs = getBreadcrumbs("help-and-advice");
</script>
